import { styled } from '@/stitches.config';

export const TableBodyStyled = styled('tbody', {});
